module.exports = "https://www.niulinkcloud.cn/_next/static/media/icon1.28495afbaae35e6fb1969df85e631100.png";